/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/terms-of-service.css';
import { Segment, Form, Header,Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import Images from '../media/privacy/privacy';

class ViewPrivacy extends Component {

	render() {
		return (
			<Segment padded='very' className="login-form" className="tos-form">
				<Form onSubmit={this.handleSubmit}>
					<div style={{display:'flex',justifyContent:'right'}}>
						<Link replace to='/' >
							<Icon name='delete' circular color='teal' corner='top right' />
						</Link>
					</div>
					<Header as='h1'>Privacy</Header>
					<Form.Field>
						<div className="tosContainer">
                        <br />
							{Images.map(image => {
								return <img key={image} src={image} alt="" className="tos-contract" />
							})}
						</div>
					</Form.Field>

				</Form>
			</Segment>
		);
	}
}

export default ViewPrivacy;
